import { useCallback } from 'react';

import { useQuery } from 'react-query';

import { KimMessage } from '../../../../backend/src/matter/subset/thread/kim-message.entity';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetKimMessages = (matterId?: string, subsetId?: string, threadId?: string) => {
  const fetcher = useFetcher();

  const fetchKimMessages = useCallback(
    (): Promise<KimMessage[]> =>
      fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/messages`),
    [fetcher, matterId, subsetId, threadId],
  );

  const query = useQuery<KimMessage[], ApiError>([QueryEntity.KimMessages, { subsetId, threadId }], fetchKimMessages, {
    enabled: !!matterId && !!subsetId && !!threadId,
  });

  // Direct fetch that bypasses the React Query cache.
  const fetchFresh = fetchKimMessages;

  return { ...query, fetchFresh };
};
